import { Restricted } from 'containers/Restricted';

import { SecondaryButton } from '@atoms/buttons/SecondaryButton';

import {
  WEBHOOKS_SELECTION_ACTIVATE_TEST_ID,
  WEBHOOKS_SELECTION_BAR_TEST_ID,
  WEBHOOKS_SELECTION_BULK_EDIT_TEST_ID,
  WEBHOOKS_SELECTION_DEACTIVATE_TEST_ID
} from './constants';

type SelectionBarProps = {
  count: number;
  onActivateAll: () => void;
  onDeactivateAll: () => void;
  onBulkEdit: () => void;
};

export const SelectionBar = ({
  count,
  onActivateAll,
  onDeactivateAll,
  onBulkEdit
}: SelectionBarProps) => (
  <div
    data-testid={WEBHOOKS_SELECTION_BAR_TEST_ID}
    className="flex w-full items-center justify-between gap-6"
  >
    <span className="text-sm text-content-secondary">
      Selected{' '}
      <strong className="font-medium text-content-primary">
        {count} {count === 1 ? 'webhook' : 'webhooks'}
      </strong>
    </span>
    <Restricted requiredPermission="developers:manage">
      <div className="flex gap-2">
        <SecondaryButton
          data-testid={WEBHOOKS_SELECTION_ACTIVATE_TEST_ID}
          onClick={onActivateAll}
        >
          Activate all
        </SecondaryButton>
        <SecondaryButton
          danger
          data-testid={WEBHOOKS_SELECTION_DEACTIVATE_TEST_ID}
          onClick={onDeactivateAll}
        >
          Deactivate all
        </SecondaryButton>
        <SecondaryButton
          data-testid={WEBHOOKS_SELECTION_BULK_EDIT_TEST_ID}
          onClick={onBulkEdit}
        >
          Bulk edit
        </SecondaryButton>
      </div>
    </Restricted>
  </div>
);
